// exported from @bingads-webui/projection-grid-base-column
export enum ColumnFormat {
  /**
   * Convert a float to a percentage. E.g.: .07 => 7%, .15 => 15%
   */
  Percentage = 'percentage',
  /**
   * Formats a float as percentage. E.g.: 42.07 => 42.07%, 0.15 => 0.15%
   */
  PercentageValue = 'percentage-value',
  /**
   * Formats value as integer.
   */
  Integer = 'integer',
  /**
   * A positive non-zero integer: 1,2,3..Number.MAX_VALUE
   */
  Natural = 'natural-integer',
  /**
   * A number with two decimal points.
   */
  Decimal = 'decimal',
  Thousandth = 'thousandth',
}

/**
 * Raw Data of a column
 * Note that data and UI is independent, however, due to historic reason, this data structure might still have some UI data.
 */
export interface ColumnRawData {
  /**
   * a unique key of the column
   */
  key: string;
  /**
   * key of friendly name, only during runtime it could be translated to real i18n name
   *
   * define example: _TL_('a friendly name')
   *
   * use example: i18n.getString(column.name)
   */
  name: string;

  /**
   * used for help link
   */
  helpId?: string;
  /**
   *
   */
  format?: ColumnFormat;
  title?: string;
}

/**
 * used for get property from odata
 *
 * The separator must be '/'
 *
 * @example 'XX/YY/ZZ'
 */
export type ColumnOdataPath = string;

/**
 * `Key` is the key of column
 *
 * `Value` is the correspond odata path of the column in the response(There is no guarantee of response, you should create differnt map for each response if possible)
 */
export type ColumnKeyOdataPathMap = Map<string, ColumnOdataPath>;
